<template>
  <settings-modal
    class="card-unblock-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <v-textarea
      v-model="form.reason"
      class="t-reason-field"
      height="100px"
      label="Reason for card unfreeze"
      outline
      :error-messages="getValidationErrorMessage('reason')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-unblock-card"
        color="primary"
        medium
        flat
        @click="unblockCard"
      >unfreeze card</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="closeModal"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_CARD_UPDATE } from '@/events/cards'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardUnblockModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { reason: null },
        unfreezeCardApiRequest: new ApiRequest(IssuingApi.unfreezeCard)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardId () {
        return this.modal.data.cardId
      },
      heading () {
        return this.modal.data.heading
      },
      error () {
        return this.unfreezeCardApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      unblockCard () {
        this.unfreezeCardApiRequest
          .execute(this.cardId, this.form.reason)
          .then(this.onCardBlockSuccess)
          .catch(() => {})
      },
      onCardBlockSuccess () {
        this.$eventHub.$emit(EVENT_CARD_UPDATE)

        this.showModal({
          name: 'SuccessFlashModal',
          data: { message: 'Card has been successfully unfrozen.' }
        })
      }
    }
  }
</script>

<style lang="scss">
  .card-unblock-modal {
    .v-textarea .v-text-field__details {
      margin-bottom: 0;
    }
  }
</style>
